import { render, staticRenderFns } from "./PromptSelectModal.vue?vue&type=template&id=b582d7de&scoped=true"
import script from "./PromptSelectModal.vue?vue&type=script&lang=js"
export * from "./PromptSelectModal.vue?vue&type=script&lang=js"
import style0 from "./PromptSelectModal.vue?vue&type=style&index=0&id=b582d7de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b582d7de",
  null
  
)

export default component.exports